import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { POST } from "config/api.config";

/** POST `Report/segment-completion/filter` */
export const submitSegmentCompletionReportFilterData = async (data = {}) => {
    try {
        const response = await POST(REPORT.SEGMENT_COMPLETION_FILTER, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
